/**
 * Horizontal & Vertical tabs. Content is lazy loaded by default
 *
 * Current implementation limited to the "line" type of Antd' tabs
 * No support for cards, editable tabs, adding a tab etc...
 */

import React from 'react';
import styled from 'styled-components';
import { Tabs as AntdTabs } from 'antd';

import { lighten, darken } from 'utils/colours';

const prefix = '.ant-tabs';
const inkBarClass = `${prefix}-ink-bar`;
const navBarClass = `${prefix}-nav`;
const tabClass = `${prefix}-tab`;
const activeTabClass = `${prefix}-tab-active`;

const StyledTabs = styled(AntdTabs).attrs({
    type: 'line',
})`
    && {
        font-family: ${({ theme }) => theme.font.regular};
    }

    ${/* sc-selector */ inkBarClass} {
        background-color: ${({ theme }) => theme.colour.primary};
    }

    ${/* sc-selector */ navBarClass} {
        ${/* sc-selector */ tabClass} {
            &:hover {
                color: ${({ theme }) => lighten(theme.colour.primary)};
            }

            &:active {
                color: ${({ theme }) => darken(theme.colour.primary)};
            }
        }

        ${/* sc-selector */ activeTabClass} {
            color: ${({ theme }) => theme.colour.primary};
        }
    }
    .ant-tabs-tab-btn:active {
        color: ${({ theme }) => darken(theme.colour.primary)};
    }

    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: ${({ theme }) => theme.colour.primary};
    }
`;

const Tabs = ({ onSelectTab = null, onChangeTab = null, onScroll = null, ...props }) => (
    <StyledTabs {...props} onTabClick={onSelectTab} onChange={onChangeTab} onTabScroll={onScroll} />
);

Tabs.Tab = AntdTabs.TabPane;

export default Tabs;
